module.exports = __webpack_public_path__ + "static/media/purchase-steps-1.b51ced4d.svg";